import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import { RoutesLink } from "../../ApiHelper/RoutesLink";
import Layout from "../../components/Layout/Layout";
const ProtectedRoute = () => {
  let token = Cookies.get("token");
  return token ? <Layout> <Outlet /> </Layout> : <Navigate to={RoutesLink?.login} />;
};
export default ProtectedRoute;
